import { render, staticRenderFns } from "./DangerDrawer.vue?vue&type=template&id=5480a8d3&scoped=true&"
import script from "./DangerDrawer.vue?vue&type=script&lang=js&"
export * from "./DangerDrawer.vue?vue&type=script&lang=js&"
import style0 from "./DangerDrawer.vue?vue&type=style&index=0&id=5480a8d3&lang=scss&scoped=true&"
import style1 from "./DangerDrawer.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5480a8d3",
  null
  
)

export default component.exports